/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredObjectFeFleetMOGs
 */
export interface MonitoredObjectFeFleetMOGs {
    /**
     * 
     * @type {number}
     * @memberof MonitoredObjectFeFleetMOGs
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoredObjectFeFleetMOGs
     */
    name: string;
}

export function MonitoredObjectFeFleetMOGsFromJSON(json: any): MonitoredObjectFeFleetMOGs {
    return MonitoredObjectFeFleetMOGsFromJSONTyped(json, false);
}

export function MonitoredObjectFeFleetMOGsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredObjectFeFleetMOGs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

export function MonitoredObjectFeFleetMOGsToJSON(value?: MonitoredObjectFeFleetMOGs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


